var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-avatar",
    { staticClass: "avatar", attrs: { variant: "primary", size: "3.5rem" } },
    [
      _c("b-icon", { attrs: { icon: _vm.icon } }),
      _vm.text
        ? _c("small", { staticClass: "text-uppercase text-sm pt-1 m-0" }, [
            _c("strong", { domProps: { innerHTML: _vm._s(_vm.text) } }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }